import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/courses", label: "Courses" },
  { to: "/teacher-training", label: "Teacher Training" },
  { to: "/exam-prep", label: "Exam Prep" },
  { to: "/consultation", label: "Study in China" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-40 bg-white/70 backdrop-blur-xl border-b border-black/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group" data-testid="nav-logo">
          <span className="w-10 h-10 bg-cinnabar text-rice flex items-center justify-center font-serif text-2xl leading-none group-hover:bg-ink transition-colors duration-300">中</span>
          <span className="hidden sm:block leading-tight">
            <span className="block font-display font-extrabold text-ink text-sm tracking-tight">CCLPT</span>
            <span className="block text-[10px] text-clay tracking-[0.18em] uppercase">Chinese Language Pedagogy</span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase().replace(/ /g, "-")}`}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors duration-200 hover:text-cinnabar ${isActive ? "text-cinnabar" : "text-ink"}`}>
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          {user ? (
            <button onClick={() => navigate("/dashboard")} data-testid="nav-dashboard-btn"
              className="px-5 py-2.5 bg-ink text-rice text-sm font-medium hover:bg-cinnabar transition-colors duration-300">
              Dashboard
            </button>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login-btn" className="text-sm font-medium text-ink hover:text-cinnabar transition-colors">Log in</Link>
              <Link to="/register" data-testid="nav-register-btn"
                className="px-5 py-2.5 bg-ink text-rice text-sm font-medium hover:bg-cinnabar transition-colors duration-300">
                Enroll Now
              </Link>
            </>
          )}
        </div>

        <button className="lg:hidden text-ink" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-black/5 bg-white px-6 py-5 space-y-4">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} onClick={() => setOpen(false)}
              className="block text-ink font-medium">{l.label}</NavLink>
          ))}
          <div className="pt-3 border-t border-black/5 flex flex-col gap-3">
            {user ? (
              <button onClick={() => { setOpen(false); navigate("/dashboard"); }} className="px-5 py-2.5 bg-ink text-rice text-sm">Dashboard</button>
            ) : (
              <>
                <Link to="/login" onClick={() => setOpen(false)} className="text-ink font-medium">Log in</Link>
                <Link to="/register" onClick={() => setOpen(false)} className="px-5 py-2.5 bg-ink text-rice text-sm text-center">Enroll Now</Link>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
